<template>
  <div>
    <!-- EDIT ATTENDANCE CODE -->
    <b-modal
      id="editModal"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      ref="editModal"
    >
      <div class="wrapper">
        <slot name="modal-header">
          <div class="modalHeader">
            <h4 class="title-for-integration">
              <slot name="modal-title"> Edit Attendance Code </slot>
            </h4>
          </div>
        </slot>
        <div class="d-block text-center modal-cusomContent">
          <div class="integrations-options">
            <span class="integrations-label" v-if="attendanceCode">
              Attendance Code
            </span>
            <treeselect
              v-model="attendanceCode"
              class="integrations-treeselect"
              :options="getIntegrationAttendanceCodes"
              :clearOnSelect="false"
              :default-expand-level="0"
              placeholder="Attendance Code"
            />
          </div>
        </div>
        <!-- action btns  -->
        <hr class="h-line" />
        <div class="action-btns">
          <button
            class="submit-btn btn btn-primary"
            size="md"
            @click="onSubmit"
            :disabled="getLoading || originalAttendanceCode == attendanceCode"
          >
            <i
              v-if="getLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
            ></i>
            <span>Edit</span>
          </button>

          <button
            class="cancel-auth btn btn-outline-danger"
            @click="$bvModal.hide('editModal')"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>

    <!-- MaASS ACTION LOADER  -->
    <b-modal
      id="massActionLoader"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      ref="massActionLoader"
    >
      <div class="d-flex loading-container">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="loader-content">
          <p>
            {{
              massSelection == "sync"
                ? "Syncing"
                : massSelection == "edit"
                ? "Editing"
                : "Ignoring"
            }}
            your data
          </p>
        </div>
      </div>
    </b-modal>

    <!-- SYNC/IGNORE CONFIRMATION -->
    <b-modal
      id="massActionConfirm"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      ref="massActionConfirm"
    >
      <div class="wrapper">
        <slot name="modal-header">
          <div class="modalHeader">
            <h4 class="title-for-integration">
              <slot name="modal-title">
                Scan
                {{
                  massSelection == "sync"
                    ? "Synced"
                    : massSelection == "edit"
                    ? "Edited"
                    : "Ignored"
                }}
                {{ massSelection == "sync" ? "to Wonde" : "" }}
              </slot>
            </h4>
          </div>
        </slot>
        <div class="d-block text-center modal-cusomContent">
          <p v-if="massSelection == 'edit'" class="mass-msg">
            Attendance code were successfully “Edited” for selected scans.
          </p>
          <p v-else class="mass-msg">
            Scans were successfully
            <b>{{ massSelection == "sync" ? "“Synced”" : "“Ignored”" }}</b
            >{{ massSelection == "sync" ? " to Wonde." : "." }}
          </p>
        </div>
        <!-- action btns  -->
        <hr class="h-line" />
        <div class="action-btns">
          <button
            class="submit-btn btn btn-primary"
            size="md"
            @click="refreshAndClose"
          >
            <span>Okay</span>
          </button>
        </div>
      </div>
    </b-modal>

    <Breadcrumb style="background-color: transparent" :items="items" />

    <section class="writeback-grid white-bg-sec">
      <DxDataGrid
        id="writeback-grid"
        :ref="dataGridRef"
        :dataSource="getIntegrationScans"
        :showBorders="false"
        :columnAutoWidth="true"
        :allowColumnReordering="true"
        :allowColumnResizing="true"
        :rowAlternationEnabled="false"
        :showColumnLines="true"
        :showRowLines="true"
        :selected-row-keys="selectedRowKeys"
        :no-data-text="'No logs yet'"
        @editor-preparing="onEditorPreparing($event)"
        @content-ready="contentReady($event)"
        @selection-changed="onSelectionChanged"
      >
        <DxScrolling :use-native="true" />
        <DxPaging :pageSize="10"></DxPaging>
        <DxSelection mode="multiple" :select-all-mode="'page'" />
        <DxFilterRow :visible="true"></DxFilterRow>
        <DxHeaderFilter :visible="true"></DxHeaderFilter>
        <DxColumnChooser :enabled="true" mode="select"></DxColumnChooser>
        <DxExport :enabled="true" :allow-export-selected-data="false" />
        <DxToolbar v-if="!isSelectedRows" :height="76">
          <!-- <DxItem name="columnChooserButton" location="before" /> -->
          <DxItem location="before" template="columnButtonTemplate" />
          <DxItem template="exportButtonTemplate" location="before" />
        </DxToolbar>

        <DxToolbar v-if="isSelectedRows">
          <DxItem location="before" template="massActionButtonsTemplate" />
        </DxToolbar>

        <DxColumn
          dataField="first_name"
          caption="First Name"
          :allow-header-filtering="false"
          :filter-operations="allowedOperations"
        ></DxColumn>

        <DxColumn
          dataField="last_name"
          caption="Last Name"
          :allow-header-filtering="false"
          :filter-operations="allowedOperations"
        ></DxColumn>

        <DxColumn
          dataField="userTypeName"
          caption="User Type"
          :allow-header-filtering="true"
          :filter-operations="allowedOperations"
        ></DxColumn>

        <DxColumn
          dataField="scan_time"
          caption="At"
          :allow-header-filtering="false"
          :filterType="'datetime'"
          :filter-operations="allowedOperations"
          :format="'dd/MM/yyyy - hh:mm a'"
          :calculate-cell-value="formatDate"
          :minWidth="200"
        ></DxColumn>

        <DxColumn
          dataField="siteName"
          caption="Site"
          :allow-header-filtering="true"
          :filter-operations="allowedOperations"
        ></DxColumn>

        <DxColumn
          dataField="attendance_code"
          caption="Attendance  Code"
          :allow-header-filtering="true"
          :filter-operations="allowedOperations"
          alignment="left"
        ></DxColumn>

        <DxColumn
          dataField="notes"
          :allow-filtering="false"
          cell-template="notes-cell"
        ></DxColumn>

        <DxColumn
          caption="Actions"
          :min-width="420"
          :allow-filtering="false"
          :allow-editing="false"
          :visible="true"
          cell-template="action-cell"
        />

        <template #exportButtonTemplate>
          <DxDropDownButton
            class="export-dropdown"
            style="margin-top: 20px"
            :items="buttonData"
            text="Export"
            @item-click="onItemClick"
          />
        </template>

        <template #columnButtonTemplate>
          <button
            class="custom-columns"
            @click="dataGrid.showColumnChooser()"
            style="margin-top: 20px"
          >
            <span class="custom-text">Columns </span>

            <span class="custom-icon">
              <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
            </span>
          </button>
        </template>

        <template #massActionButtonsTemplate>
          <div style="display: -webkit-inline-box; margin-top: 7%">
            <p class="toolbar-logs-count">
              {{ selectedRows.length }}
              {{ selectedRows.length > 1 ? "logs" : "log" }} selected
            </p>

            <button
              class="toolbar-action-buttons toolbar-main"
              @click="performMassAction('sync')"
            >
              <span class="custom-text">Sync</span>
            </button>

            <button
              class="toolbar-action-buttons toolbar-main"
              @click="performMassAction('edit')"
            >
              <span class="custom-text">Edit</span>
            </button>

            <button
              class="toolbar-action-buttons toolbar-alert"
              @click="performMassAction('ignore')"
            >
              <span class="custom-text">Ignore</span>
            </button>
          </div>
        </template>

        <template #notes-cell="{ data }">
          <div
            v-html="data.value ? data.value.replace(/\n/g, '<br>') : ''"
          ></div>
        </template>

        <template #action-cell="{ data }">
          <div>
            <button
              class="toolbar-action-buttons toolbar-main"
              :disabled="isSelectedRows || sync || ignore"
              @click="syncScan(data.data)"
            >
              <i
                v-if="sync"
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
              ></i>
              <span class="custom-text">Sync</span>
            </button>

            <button
              class="toolbar-action-buttons toolbar-main"
              @click="onEditScan(data.data)"
              :disabled="isSelectedRows || sync || ignore"
            >
              <span class="custom-text">Edit</span>
            </button>

            <button
              class="toolbar-action-buttons toolbar-alert"
              @click="ignoreScan(data.data)"
              :disabled="isSelectedRows || sync || ignore"
            >
              <i
                v-if="ignore"
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
              ></i>
              <span class="custom-text">Ignore</span>
            </button>
          </div>
        </template>
      </DxDataGrid>
    </section>
  </div>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import { mapActions, mapGetters } from "vuex";
// import DxSelectBox from "devextreme-vue/select-box";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@riophae/vue-treeselect";
const dataGridRef = "dataGrid";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import "whatwg-fetch";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxPaging,
  DxSelection,
  DxFilterRow,
  DxHeaderFilter,
  DxColumnChooser,
  DxExport,
  DxColumn,
  DxScrolling,
  //   DxButton,
  //   DxLoadPanel,
  //   DxPopup,
  DxToolbar,
  DxItem,
} from "devextreme-vue/data-grid";

export default {
  components: {
    Breadcrumb,
    // DxSelectBox,
    Treeselect,
    DxDataGrid,
    DxPaging,
    DxSelection,
    DxFilterRow,
    DxHeaderFilter,
    DxColumnChooser,
    DxExport,
    DxColumn,
    DxScrolling,
    // DxButton,
    // DxLoadPanel,
    // DxPopup,
    DxToolbar,
    DxItem,
    DxDropDownButton,
  },
  data() {
    return {
      dataGridRef,
      buttonData: ["Excel", "CSV", "PDF"],
      getLoading: false,
      sync: false,
      ignore: false,
      edit: false,
      allowedOperations: ["contains"],
      items: [
        {
          text: "Integrations",
          to: { name: "addIntegration" },
        },
        {
          text: this.$route.query.integName,
          to: {
            name: "viewIntegration",
            params: {
              integId: this.getIntegId,
              integName: this.$route.query.integName,
            },
          },
          active: true,
        },
      ],
      title: "Integrations",
      isSelectedRows: false,
      dataSource: [
        {
          firstName: "first",
          lastName: "last",
          userType: "user Type",
          at: new Date(),
          site: "site",
          attendanceCode: 2,
          notes:
            "The scan is added to a site that is not included in this integration.",
        },
      ],
      selectedRowKeys: [],
      selectedRows: [],
      searchPanel: { visible: true },
      filterRow: { visible: true },
      editing: { mode: "batch", allowUpdating: true },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: "always",
        deferred: true,
      },
      selectedAttendanceCode: null,
      loading: false,
      loadingMessage: "",
      showSuccessPopup: false,
      selectedRowCount: 0,
      showRefreshButton: false,
      massSelection: "",
      scanId: "",
      massSelectionItems: [
        { text: "Sync", value: "sync" },
        { text: "Ignore", value: "ignore" },
        { text: "Edit", value: "edit" },
      ],
      popupVisible: false,
      popupTitle: "popupTitle",
      loadPanelVisible: false,
      loadPanelMessage: "loadPanelMessage",
      originalAttendanceCode: null,
      attendanceCode: null,
    };
  },
  computed: {
    ...mapGetters("integration", [
      "getIntegId",
      "getIntegrationScans",
      "getIntegrationAttendanceCodes",
    ]),
    hasSelectedRows() {
      return this.selectedRowCount > 0;
    },
    dataGrid() {
      return this.$refs[this.dataGridRef].instance;
    },
  },
  beforeMount() {
    this.fetchIntegrationScans(this.getIntegId);
    this.fetchIntegrationAttendanceCodes(this.getIntegId);
  },
  methods: {
    ...mapActions("integration", [
      "syncIntegrationScans",
      "ignoreIntegrationScans",
      "editIntegrationScans",
      "fetchIntegrationScans",
      "fetchIntegrationAttendanceCodes",
    ]),
    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = "Search";
      }
    },
    onSelectionChanged(e) {
      this.selectedRows = e.selectedRowsData;
      console.log(this.selectedRows, e);
      if (this.selectedRows.length > 0) this.isSelectedRows = true;
      else this.isSelectedRows = false;
      console.log("isSelectedRows", this.isSelectedRows);
    },
    formatDate(rowData) {
      return new Date(rowData.scan_time);
    },
    onItemClick(e) {
      if (e.itemData == "Excel") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Errors.xlsx"
            );
          });
        });
        // e.cancel = true;
      } else if (e.itemData == "CSV") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.csv.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Errors.csv"
            );
          });
        });
      } else if (e.itemData == "PDF") {
        const doc = new jsPDF("landscape");
        // settings.SettingsExport.Landscape = true;
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: this.dataGrid,
        }).then(() => {
          doc.save("Errors.pdf");
        });
      }
    },
    clearFilter() {
      this.$refs[this.dataGridRef].instance.clearFilter();
    },

    contentReady() {
      this.setColumnChooserPosition();
    },

    setColumnChooserPosition() {
      // this.dataGrid.showColumnChooser();
      // console.log("columnChooserView");

      var columnChooserView = this.dataGrid.getView("columnChooserView");

      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }

      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: "left top",
        at: "left top",
        offset: "0 50",
      });
    },
    onEditScan(data) {
      console.log("onEditScan", data);
      this.massSelection = "";
      this.scanId = data.id;
      this.originalAttendanceCode = this.attendanceCode =
        data.attendance_code_id;
      this.$bvModal.show("editModal");
    },
    syncScan(data) {
      this.sync = true;
      this.syncIntegrationScans({
        ids: [data.id],
        intgId: this.getIntegId,
      }).then(() => {
        this.sync = false;
      });
    },
    ignoreScan(data) {
      this.ignore = true;
      this.ignoreIntegrationScans({
        ids: [data.id],
        intgId: this.getIntegId,
      }).then(() => {
        this.ignore = false;
      });
    },
    syncSelectedRows() {
      this.loading = true;
      this.loadingMessage = "Syncing your data...";
      setTimeout(() => {
        // this.gridInstance.getSelectedRowsData().then((selectedRows) => {
        // Code to sync selected rows
        this.loading = false;
        this.showSuccessPopup = true;
        // });
      }, 5000); // Replace with your sync logic
    },
    ignoreSelectedRows() {
      this.loading = true;
      this.loadingMessage = "Ignoring your data...";
      setTimeout(() => {
        // this.gridInstance.getSelectedRowsData().then((selectedRows) => {
        // Code to ignore selected rows
        this.loading = false;
        this.showSuccessPopup = true;
        // });
      }, 3000);
    },
    async performMassAction(action) {
      this.massSelection = action;
      if (this.massSelection === "sync" || this.massSelection === "ignore") {
        this.$bvModal.show("massActionLoader");
        const ids = [];
        for (let i = 0; i < this.selectedRows.length; i++) {
          ids.push(this.selectedRows[i].id);
        }
        if (this.massSelection === "sync") {
          this.syncIntegrationScans({
            ids,
            intgId: this.getIntegId,
          }).then(() => {
            this.$bvModal.hide("massActionLoader");
            this.$bvModal.show("massActionConfirm");
          });
        } else {
          this.ignoreIntegrationScans({
            ids,
            intgId: this.getIntegId,
          }).then(() => {
            this.$bvModal.hide("massActionLoader");
            this.$bvModal.show("massActionConfirm");
          });
        }
      } else {
        this.$bvModal.show("editModal");
      }
    },

    refreshAndClose() {
      this.dataGrid.refresh().then(() => {
        this.$bvModal.hide("massActionConfirm");
        this.dataGrid?.deselectAll();
      });
    },
    async onSubmit() {
      if (this.massSelection) {
        this.$bvModal.hide("editModal");
        this.$bvModal.show("massActionLoader");
        const ids = [];
        for (let i = 0; i < this.selectedRows.length; i++) {
          ids.push(this.selectedRows[i].id);
        }
        this.editIntegrationScans({
          ids,
          attendanceCodeId: this.attendanceCode,
          integId: this.getIntegId,
        }).then(() => {
          this.$bvModal.hide("massActionLoader");
          this.$bvModal.show("massActionConfirm");
        });
      } else {
        console.log("else", this.getIntegId);
        this.getLoading = true;
        const ids = [this.scanId];
        this.editIntegrationScans({
          ids,
          attendanceCodeId: this.attendanceCode,
          integId: this.getIntegId,
        }).then(() => {
          this.$bvModal.hide("editModal");
          this.getLoading = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mass-msg {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;

  color: #787878;
}
.toolbar-action-buttons:disabled {
  opacity: 0.5;
  color: #c3c3c3;
}
.toolbar-alert {
  background-color: #f46a6a;
}
.toolbar-main {
  background-color: #103f5e;
}
.title-for-integration {
  font-weight: 700;
  font-size: 17px;
  line-height: 20px;
  margin-bottom: 37px;
  color: #000000;
}
.toolbar-logs-count {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0em;
  color: #939393de;
  margin-inline-start: 28px;
  margin-top: 15px;
  margin-top: 6px;
  margin-inline-end: 24px;
}
</style>

<style lang="scss">
.writeback-grid {
  .dx-toolbar {
    height: 76px;
  }
}

div#editModal___BV_modal_body_ {
  .integrations-options {
    position: relative;
    margin-top: 17px;
    .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      padding-top: 20px;
      padding-inline-start: 15px;
      letter-spacing: 0.25px;

      color: #787878;
    }
    .vue-treeselect__single-value {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */

      letter-spacing: 0.25px;
      padding-top: 30px;
      padding-inline-start: 15px;
      color: #4a4a4a !important;
    }
    .integrations-label {
      position: absolute;
      color: #103f5e;
      margin-top: 10px;
      margin-inline-end: 0;
      margin-bottom: 0;
      margin-inline-start: -185px;
      z-index: 2;

      font-size: 12px;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.25px;
      text-align: start;
    }
  }
  .vue-treeselect__control {
    width: 416px;
    height: 55px;
    background: #f2f2f2 !important;
    margin-bottom: 17px;
    // padding-inline-start: 4px;
    border-radius: 4px;
    border: none;
    position: relative;

    .vue-treeselect__multi-value {
      min-height: 55px !important;
      display: flex;
      flex-wrap: wrap;
      .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
        position: absolute;
        top: 20px;
        inset-inline-start: 10px;

        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        // margin-inline-start: 15px;
        /* identical to box height, or 106% */

        letter-spacing: 0.25px;

        color: #787878;
      }
    }
  }
  .vue-treeselect svg {
    fill: #787878;
  }
  .vue-treeselect__multi-value-item {
    cursor: pointer;
    display: inline-table;
    background: #103f5e;
    padding: 0px !important;
    border: none;
    border-radius: 6px;
    height: 39px;
    // min-width: 92px;
    color: #ffff;
    font-size: 12px;
    vertical-align: top;

    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
  }
  .vue-treeselect__value-remove {
    border: none !important;
    width: 33px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
  }
  .vue-treeselect__x-container {
    display: none;
  }
  span.vue-treeselect__multi-value-label {
    padding: 11px 14px;
  }
  .vue-treeselect__menu::-webkit-scrollbar {
    width: 9px;
    height: 30px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-track {
    background: #c7c7c7;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
    margin-top: 21px !important;
    margin-bottom: 13px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
  }
  .vue-treeselect__list {
    width: 406px;
  }
  .vue-treeselect__option {
    border-top: 1px solid #ebebeb;
    padding-inline-end: 10px;
  }
  .vue-treeselect__label {
    font-size: 16px;
    font-weight: 400;
    font-size: 16px;
    color: #787878;
    padding-inline-start: 12px;
    padding-top: 10px;
    padding-bottom: 10px;
    white-space: normal;
  }
  .vue-treeselect__list-item {
    width: 98% !important;
  }

  .vue-treeselect__list:first-of-type
    > .vue-treeselect__list-item:first-of-type
    > .vue-treeselect__option:first-of-type {
    border-top: none;
  }
  .vue-treeselect__input-container {
    font-size: 16px;
    margin-top: 15px;
    padding-inline-start: 15px;
  }
  .vue-treeselect__checkbox {
    background-color: #ffffff !important;
    padding: 5px !important;
    border: 3px solid #787878 !important;
    border-radius: 3px !important;
    width: 17px !important;
    height: 17px !important;
  }
  .vue-treeselect__checkbox--checked {
    background-color: #787878 !important;
    border: solid #787878 3px !important;
  }
  .vue-treeselect__check-mark,
  .vue-treeselect__minus-mark {
    background-color: #787878 !important;
    border: none !important;
  }
  .vue-treeselect--disabled .vue-treeselect__placeholder {
    opacity: 0.3;
    // margin-inline-start: 20px;
  }
  .disabled-svg {
    opacity: 0.3;
  }
}

div#massActionLoader___BV_modal_content_ {
  background: white;
  border: none;
  // height: 85px !important;
  width: 291px !important;
  border-radius: 60px;
  margin-top: 50%;
  // inset-inline-start: 20%;
  div#massActionLoader___BV_modal_body_ {
    padding-top: 19px !important;
    padding-inline-end: 36px !important;
    padding-bottom: 19px !important;
    padding-inline-start: 30px !important;
    .loading-container {
      p {
        font-weight: 700;
        font-size: 16px;
        color: #000000;
        margin-bottom: 0px;
        margin-top: 7px;
        line-height: 152%;
      }
    }
    .spinner-border {
      color: #103f5e;
      border-width: 0.35em;
      width: 38px;
      height: 38px;
      margin-inline-end: 20px;
      border-right-color: #d9d9d9;
    }
  }
}
</style>
